<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.66" stroke-linecap="round" stroke-linejoin="round" class="feather feather-loader">
  <line x1="12" y1="2" x2="12" y2="6"></line>
  <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
  <line x1="18" y1="12" x2="22" y2="12"></line>
  <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
  <line x1="12" y1="18" x2="12" y2="22"></line>
  <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
  <line x1="2" y1="12" x2="6" y2="12"></line>
  <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
</svg>
<style lang="postcss">
  line {
    animation: opaciate 0.8s linear infinite;
  }
  line:nth-child(2) {
    animation-delay: 0.1s;
  }
  line:nth-child(3) {
    animation-delay: 0.2s;
  }
  line:nth-child(4) {
    animation-delay: 0.3s;
  }
  line:nth-child(5) {
    animation-delay: 0.4s;
  }
  line:nth-child(6) {
    animation-delay: 0.5s;
  }
  line:nth-child(7) {
    animation-delay: 0.6s;
  }
  line:nth-child(8) {
    animation-delay: 0.7s;
  }
  @keyframes opaciate {
    100% {
      opacity: 0.1;
    }
  }
</style>